const IRREGULAR_PLURALS: { [index: string]: string } = {
    is: 'are',
    has: 'have',
};

export function get(str: string, count: number, customPlural?: string) {
    return count === 1 ? str : customPlural || IRREGULAR_PLURALS[str] || createDefaultPlural(str);
}

export function getWithCount(str: string, count: number, customPlural?: string) {
    return `${count} ${get(str, count, customPlural)}`;
}

function createDefaultPlural(str: string) {
    const lastI = str.length - 1;
    return isYSingular(str, lastI) ? str.slice(0, lastI) + 'ies' : str + 's';
}

function isYSingular(str: string, lastI: number) {
    return str.length > 2 && str[lastI] === 'y' && !isVowel(str[lastI - 1]);
}

function isVowel(char: string) {
    return char.match(/[aeiou]/);
}
